module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_troendelag_neg.f462088a.png";